export default {
  name: "App",
  components: {},
  mounted() {
    // 解决页面不刷新问题
    if (location.search.startsWith("?page=")) {
      let name = location.search.replace(/^\?page=/, "").replace("#/", "");
      window.location.href = location.protocol + "//" + location.host + location.pathname + "#/" + name;
    }
  }
};